module.exports = __webpack_public_path__ + "img/posterSearch-des2.2c4ece31.png";